<h1 mat-dialog-title >Nueva ayuda</h1>
<div mat-dialog-content>
    <form [formGroup]="ayudaForm">
  
  
      <p style="color: black; font-weight: bold"  >Escoja una opción:</p><br>
  
  
      <mat-radio-group formControlName="tipoTramite" (change)="changeEstado($event)">
        <mat-radio-button value="AYUDA MOVES" >Moves III 2025</mat-radio-button><br>
        <mat-radio-button value="AYUDA REINICIA" >Reinicia Auto</mat-radio-button><br>
      </mat-radio-group>
      <br>
  
      <div class="row">
  
  
  
  
        <mat-form-field appearance="outline" class="col-lg-4 col-md-4 col-sm-4 col-4" *ngIf="show">
          <mat-label>Km</mat-label>
          <input matInput matNativeControl type="text"
                 formControlName="km">
  
        </mat-form-field>
  
        <mat-form-field appearance="outline" class="offset-1 col-lg-4 col-md-4 col-sm-4 col-4" *ngIf="show">
          <mat-label>País de origen</mat-label>
          <input matInput matNativeControl type="text"
                 formControlName="paisOrigen">
  
        </mat-form-field>
  
        <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
          <mat-label>Número de pedido</mat-label>
          <input matInput matNativeControl type="text"
                 formControlName="numPedido">
  
        </mat-form-field>
  
  
      </div>
  
  
  
  
    </form>
  
  </div>
  <div mat-dialog-actions>
    <button mat-button class="btn-block btn-secondary"  (click)="onNoClick()" >Cancelar</button>
    <button mat-button class="btn-block btn-secondary" (click)="onSiguiente()" [disabled]="!seleccionado">Siguiente</button>
  </div>
